import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    ATTENDANCE_REQUEST,
    ATTENDANCE_APPROVAL,
    ATTENDANCE_LIST
} from "./type";

export const attendanceRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.attendanceRequest}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ATTENDANCE_REQUEST,
            payload: data.response,
        });
        return data.response;
    }
};

export const regularizationList = (page=1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.attendanceRequestList}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ATTENDANCE_LIST,
            payload: data.response.data,
        });
        return data.response;
    }
};